module.exports = __webpack_public_path__ + "img/y-232.f8ab1ebd.png";